import { render } from "./footer.vue?vue&type=template&id=73cf0586"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
script.render = render

export default script